import {BlurEvent, ChangeEvent, DataDisplayEvent, LookupModelSearchEvent, Snackbar, Textbox} from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { Api, StringUtil } from "@mcleod/core";
import { AutogenLayoutFreightMatchingUser } from "./autogen/AutogenLayoutFreightMatchingUser";

export class FreightMatchingUser extends AutogenLayoutFreightMatchingUser {
    refreshDfmTrackingProviders?: () => void;

    textboxUserGroupBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.user_type = 'M';
    }

    textboxFmAuthTypeOnChange(event: ChangeEvent) {
        this.setAuthComponentVisibility(event.newValue);
    }

    async textboxDfmProviderOnBlur(event: BlurEvent) {
        await this.addDfmProvider(event)
    }

    textboxDfmProviderOnDataDisplay(event: DataDisplayEvent) {
        this.textboxDfmProvider.quickInfoOverrideMethod = async () => null;
    }

    setAuthComponentVisibility(selectedValue: string) {
        this.textboxFmBearerToken.visible = this.textboxFmBearerToken.required = false;
        this.textboxFmUsername.visible = this.textboxFmUsername.required = false;
        this.textboxFmPassword.visible = this.textboxFmPassword.required = false;

        switch (selectedValue) {
            case "Bearer Token":
                // Show only the bearer token field
                this.textboxFmBearerToken.visible = this.textboxFmBearerToken.required = true;
                break;
            case "Basic":
                // Show username and password fields
                this.textboxFmUsername.visible = this.textboxFmUsername.required = true;
                this.textboxFmPassword.visible = this.textboxFmPassword.required = true;
                break;
            default:
                // Else hide all auth-related fields
                break;
        }
    }

    async addDfmProvider(event: BlurEvent): Promise<void> {
        const textbox = event.target as Textbox;
        const enteredName = textbox.text?.trim() ?? "";

        if (StringUtil.isEmptyString(enteredName)) {
            return;
        }

        const existingResult = await this.resolveProvider(enteredName, false);
        if (existingResult.id != null) {
            this.activeRow.set("dfm_provider", existingResult.id);
            return;
        }

        const shouldCreate = await CommonDialogs.showYesNo(
            `Tracking Provider Name '${enteredName}' does not exist. Add it now?`,
            "Add Tracking Provider"
        );

        if (!shouldCreate) {
            textbox.text = "";
            this.activeRow.set("dfm_provider", null);
            textbox.focus();
            return;
        }

        const createdResult = await this.resolveProvider(enteredName, true);
        if (createdResult.id == null) {
            Snackbar.showWarningSnackbar("Unable to add tracking provider. Please try again.");
            textbox.focus();
            return;
        }

        this.activeRow.set("dfm_provider", createdResult.id);
        this.refreshDfmTrackingProviders?.();
    }

    private async resolveProvider(providerName: string, createIfMissing: boolean): Promise<{ id: string | null }> {
        try {
            const response = await Api.post("lme/powerbroker/resolve-dfm-tracking-provider", {
                provider_name: providerName,
                create_if_missing: createIfMissing
            });
            return { id: response?.data?.[0]?.id ?? null };
        } catch (error) {
            return { id: null };
        }
    }
}
